// ONBOARDING-P3: Operator › Onboarding: `/operator/onboarding` (the clients with an onboarding
// case) and `/operator/onboarding/{companyId}` (one case: proposal, approvals, seating, close).
// Agency users only; anyone else gets the not-found page and no API call.
import { createRoute } from "@tanstack/react-router";
import { isOperator } from "../features/company";
import { OnboardingCasePage } from "../features/operator/onboarding-case-page";
import { OnboardingCasesPage } from "../features/operator/onboarding-cases-page";
import { useSession } from "../features/use-feature";
import { NotFoundPage } from "../pages/status-pages";
import { OperatorShell, PlainShell } from "../shell/app-shell";
import { authedRoute } from "./_authed";

export const operatorOnboardingRoute = createRoute({
  getParentRoute: () => authedRoute,
  path: "operator/onboarding",
  component: function OnboardingCasesScreen() {
    const { api } = operatorOnboardingRoute.useRouteContext();
    const { me } = useSession();
    if (!isOperator(me))
      return (
        <PlainShell me={me} api={api} current={null}>
          <NotFoundPage />
        </PlainShell>
      );
    return (
      <OperatorShell me={me} api={api}>
        <OnboardingCasesPage api={api} />
      </OperatorShell>
    );
  },
});

export const operatorOnboardingCaseRoute = createRoute({
  getParentRoute: () => authedRoute,
  path: "operator/onboarding/$companyId",
  component: function OnboardingCaseScreen() {
    const { api } = operatorOnboardingCaseRoute.useRouteContext();
    const { companyId } = operatorOnboardingCaseRoute.useParams();
    const { me } = useSession();
    if (!isOperator(me))
      return (
        <PlainShell me={me} api={api} current={null}>
          <NotFoundPage />
        </PlainShell>
      );
    return (
      <OperatorShell me={me} api={api}>
        <OnboardingCasePage key={companyId} api={api} companyId={companyId} />
      </OperatorShell>
    );
  },
});
